module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Introduction#fm-1"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION BY")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("APP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Note#fm-2"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE ON THE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT BY")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITA")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILLER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_FM"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMILY")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("REE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("I. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTECEDENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_vm._v("II. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILDHOOD")]), _vm._v(" 1834-1843")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OYHOOD")]), _vm._v(" 1843-1848")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YNCOMBE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUTHGATE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XFORD")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OREIGN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALES AND")]), _vm._v(" E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XCURSIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OME")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITH THE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NGLISH")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEASURES AND")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMAN")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SMERALDA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("READFUL")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOODS AND THE")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AST OF THE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLITARY")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMPIRE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROGLIN")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANGE AND")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TORIES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONDON")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALKS AND")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OCIETY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISITS AND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. A H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALT IN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IFE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DVENTURE IN")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEASURE AND")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIN")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XX. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AREWELL")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDEX")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/ch1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0